/**
 * Ticket SK2: Rückkehr nach einem abgebrochenen Bezahlvorgang.
 *
 * Auch hier wird nichts geschrieben. Der Abbruch wird erst wirksam, wenn der
 * Zahlungsdienst den Vorgang als verfallen meldet — oder der Aufräumlauf ihn
 * nach 30 Tagen entfernt.
 */

import { createFileRoute, Link } from "@tanstack/react-router";
import { Layout } from "@/components/Layout";

const TITLE = "Vorgang abgebrochen | creategy";
const DESCRIPTION = "Der Bezahlvorgang wurde abgebrochen. Es ist nichts abgebucht worden.";

export const Route = createFileRoute("/kaufen/abbruch")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: CancelPage,
});

function CancelPage() {
  return (
    <Layout>
      <section>
        <div className="section-y mx-auto w-full max-w-[820px] px-6 md:px-12">
          <h1 className="heading-h1">Vorgang abgebrochen</h1>
          <p className="mt-6 font-body text-base text-muted-foreground">
            Es ist nichts abgebucht worden. Sie können den Kauf jederzeit erneut starten oder das
            Angebot unverbindlich anfragen.
          </p>
          <p className="mt-8">
            <Link
              to="/kontakt"
              className="inline-block rounded-sm bg-brand-button px-6 py-4 font-display text-base font-extrabold text-brand-button-foreground transition-opacity hover:opacity-90"
            >
              Unverbindlich anfragen
            </Link>
          </p>
        </div>
      </section>
    </Layout>
  );
}
